import type { UIComponent } from '../ui-components';
import { BoatCard, type BoatCardData } from './BoatCard';
import { LocationCard, type LocationCardData } from './LocationCard';
import { LinkCard, type LinkCardData } from './LinkCard';

interface ComponentRendererProps {
  component: UIComponent;
}

export function ComponentRenderer({ component }: ComponentRendererProps): React.JSX.Element | null {
  switch (component.type) {
    case 'boat-card':
      return <BoatCard data={component.data as unknown as BoatCardData} />;
    case 'location-card':
      return <LocationCard data={component.data as unknown as LocationCardData} />;
    case 'link-card':
      return <LinkCard data={component.data as unknown as LinkCardData} />;
    default:
      console.warn('[Audientic] Unknown ui-component type:', component.type);
      return null;
  }
}
